export default "__VITE_ASSET__fHFQbnIG__"